import { Paper, Typography, Box, LinearProgress } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const AnalyticsCard = ({ name, value, percentage }) => {
  const isPositive = percentage >= 0;

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2.5,
        minWidth: 200,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #f5f7fa, #e4e8ec)',
        transition: '0.3s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      {/* Title */}
      <Typography variant="subtitle2" color="text.secondary">
        {name}
      </Typography>

      {/* Value */}
      <Typography variant="h5" fontWeight="bold" sx={{ my: 1 }}>
        {value}
      </Typography>

      {/* Percentage + Icon */}
      <Box display="flex" alignItems="center" gap={1}>
        {isPositive ? (
          <TrendingUp sx={{ color: 'success.main', fontSize: 18 }} />
        ) : (
          <TrendingDown sx={{ color: 'error.main', fontSize: 18 }} />
        )}

        <Typography
          variant="body2"
          sx={{
            color: isPositive ? 'success.main' : 'error.main',
            fontWeight: 500,
          }}
        >
          {percentage}%
        </Typography>
      </Box>

      {/* Mini Progress Bar */}
      <LinearProgress
        variant="determinate"
        value={Math.min(Math.abs(percentage), 100)}
        sx={{
          mt: 1.5,
          height: 6,
          borderRadius: 5,
          backgroundColor: '#ddd',
          '& .MuiLinearProgress-bar': {
            backgroundColor: isPositive ? '#4caf50' : '#f44336',
          },
        }}
      />
    </Paper>
  );
};

export default AnalyticsCard;
